/* eslint-disable react/no-unknown-property */
import React, { PureComponent } from 'react';

import { Checklist } from 'components/checklist';
import { SearchFilter } from 'components/input/search';
import { translate } from 'components/translate';
import deburr from 'lodash/deburr';
import difference from 'lodash/difference';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { CHECKLIST_SELECTED_LIMIT } from '../../constants';

const PORTUGUESE_LANGUAGES = {
  BRAZIL: 'PT_BR',
  PORTUGAL: 'PT_PT'
};

@inject((stores) => ({
  locales: stores.SubtitleStore.supportedLangs
}))
@observer
@translate()
export default class SubtitleTranslationChecklist extends PureComponent {
  static propTypes = {
    locales: PropTypes.array,
    mediaId: PropTypes.string,
    t: PropTypes.func,
    onSelectLang: PropTypes.func,
    translatedCodes: PropTypes.array
  };

  state = {
    searchedValue: '',
    selectedLocales: []
  };

  languages = {};

  constructor(props) {
    super(props);
    this.changeFilter = this.changeFilter.bind(this);
    this.changeChecklist = this.changeChecklist.bind(this);
  }

  get filteredLocales() {
    const { mediaId, locales, translatedCodes } = this.props;

    const isPortugueseLegend = Boolean(
      (translatedCodes || []).find(
        (translatedCode) =>
          translatedCode === PORTUGUESE_LANGUAGES.BRAZIL ||
          translatedCode === PORTUGUESE_LANGUAGES.PORTUGAL
      )
    );

    const regexSearchedValue = new RegExp(
      deburr(this.state.searchedValue),
      'i'
    );

    return locales[mediaId].filter(
      (locale) =>
        (isPortugueseLegend &&
          locale !== PORTUGUESE_LANGUAGES.BRAZIL &&
          locale !== PORTUGUESE_LANGUAGES.PORTUGAL &&
          regexSearchedValue.test(deburr(this.getMemoizedLanguage(locale)))) ||
        (!isPortugueseLegend &&
          regexSearchedValue.test(deburr(this.getMemoizedLanguage(locale))))
    );
  }

  get formattedLocales() {
    const { selectedLocales } = this.state;

    const filteredLocales = this.filteredLocales.map((locale) => ({
      checked: selectedLocales.includes(locale),
      name: this.getMemoizedLanguage(locale),
      value: locale
    }));

    return this.getSortedLocales(filteredLocales);
  }

  get selectedLocalesFiltered() {
    return difference(this.state.selectedLocales, this.filteredLocales);
  }

  get selectedLimit() {
    return CHECKLIST_SELECTED_LIMIT - this.selectedLocalesFiltered.length;
  }

  getSortedLocales(locales) {
    return locales.sort((a, b) => a.name.localeCompare(b.name));
  }

  getMemoizedLanguage = (locale) => {
    if (!this.languages[locale]) {
      this.languages[locale] = this.props.t(`supported_languages.${locale}`);
    }

    return this.languages[locale];
  };

  changeFilter = (searchedValue) => {
    this.setState({ searchedValue });
  };

  changeChecklist = ({ target: { value: selectedLocales } }) => {
    const { onSelectLang } = this.props;

    const newSelectedLocales = [
      ...this.selectedLocalesFiltered,
      ...selectedLocales
    ];

    this.setState({ selectedLocales: newSelectedLocales });
    onSelectLang && onSelectLang(newSelectedLocales);
  };

  render() {
    return (
      <div nopadding className="subtitle__translation__checklist__panel">
        <SearchFilter items={this.formattedLocales}>
          <SearchFilter.SearchInput
            wait={0}
            maxLength="30"
            autoComplete="off"
            placeholder="player_subtitles.translate.search_langs"
            onChange={this.changeFilter}
          />

          <Checklist
            className="subtitle__translation__checklist"
            selectedLimit={this.selectedLimit}
            onChange={this.changeChecklist}
          >
            <Checklist.Items />
          </Checklist>
        </SearchFilter>
      </div>
    );
  }
}
